 var vehicle_rates = new Array();
 vehicle_rates["Car"]=420;
 vehicle_rates["Pickup"]=640;
 vehicle_rates["SVan"]=792;
 vehicle_rates["LVan"]=960;
 vehicle_rates["Truck"]=1120;

function getVehicleRate(formID)
{
    var vehicleRate=0;
    var theForm = document.forms[formID];
    var selectedVehicle = theForm.elements["vehicle"];
     
    vehicleRate = vehicle_rates[selectedVehicle.value];

    return vehicleRate;
}

function getSchedule(formID)
{
    var workingDays=0;
    var theForm = document.forms[formID];
    var selectedOption = theForm.elements["schedule"];
    workingDays = selectedOption.value;

    return workingDays;
}

Number.prototype.format = function(n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
};
        
function calculateTotal(formID, resultID)
{
    var totalRate = getVehicleRate(formID) * getSchedule(formID) / 7 * 30;
    
    var divobj = document.getElementById(resultID);
    //divobj.style.display='flex';
    divobj.innerHTML = "Rs "+totalRate.format();

}